import {css, type Theme} from '@emotion/react';
import {configureFonts, getFontThemeList} from '@nfq/next-fonts';
import {createConfig} from '@nfq/react-grid';

import {globalCss, shadows, themeColors} from 'UI/utils/theme';

export const fontDefinitions = configureFonts({Lato: []});

export const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
export const {configType, globalCss: globalGridCss} = createConfig(breakpoints, {
    baseSpacing: 0.4,
    columnGap: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 24,
        xl: 32,
        xxl: 32
    },
    container: {
        xs: 'fluid',
        sm: 'fluid',
        md: 'fluid',
        lg: 'fluid',
        xl: 1920,
        xxl: 1920
    },
    containerPadding: {
        xs: 20,
        sm: 20,
        md: 32,
        lg: 32,
        xl: 32,
        xxl: 64
    }
});

export const theme: Theme = {
    boxShadows: shadows,
    colors: themeColors,
    fonts: getFontThemeList(fontDefinitions)
};

export const globals = css`
    ${globalCss}

    ${globalGridCss}

    *,
    &::before,
    &::after {
        box-sizing: border-box;
    }

    * {
        -webkit-tap-highlight-color: transparent;
    }

    html {
        font-size: 10px;
        font-family: "aktiv-grotesk", Helvetica, Arial, sans-serif;
    }

    html, body {
        background-color: ${themeColors.bgPrimary};
        color: ${themeColors.primary};
        margin: 0;
        min-height: 100%;
        padding: 0;
        scroll-behavior: smooth;
    }

    #__next {
        min-height: 100%;
    }
`;